import { render, staticRenderFns } from "./CmgHeaderUserIcon.vue?vue&type=template&id=c53cac90&scoped=true&lang=pug&"
import script from "./cmg-header-user-icon.ts?vue&type=script&lang=ts&"
export * from "./cmg-header-user-icon.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHeaderUserIcon.vue?vue&type=style&index=0&id=c53cac90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53cac90",
  null
  
)

export default component.exports